export default function (element, data) {
  element.addEventListener("click", function (event) {
    event.stopPropagation();
  });

  element.querySelector(".current").addEventListener("click", function (event) {
    const isOpen = element.classList.contains("open");
    window.dispatchEvent(new Event("closePopups"));
    setTimeout(function () {
      element.classList.toggle("open", !isOpen);
    }, 20);
  });

  window.addEventListener("click", function (event) {
    element.classList.remove("open");
  });

  window.addEventListener("closePopups", function (event) {
    element.classList.remove("open");
  });
}
